import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const TabHeader = styled.div`
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #eee;
  padding: 12px 0;
`;

const TabButton = styled.button`
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => (props.active ? "#000" : "#999")};
  padding-bottom: 10px;
  border-bottom: ${(props) => (props.active ? "2px solid #000" : "none")};
  cursor: pointer;

  &:hover {
    color: #000;
  }
`;

const TabContent = styled.div`
  margin-top: 32px;
`;

const TabsSection = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.key || "");

  return (
    <TabsWrapper>
      <TabHeader>
        {tabs.map((tab) => (
          <TabButton
            key={tab.key}
            active={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </TabButton>
        ))}
      </TabHeader>

      <TabContent>
        {tabs.find((tab) => tab.key === activeTab)?.content}
      </TabContent>
    </TabsWrapper>
  );
};

TabsSection.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
};

export default TabsSection;
